import Button from "../../../components/atoms/button";
import TemplateFrame from "../../../components/atoms/templateFrame";

function Banner() {
  return (
    <TemplateFrame>
      <div className="flex flex-col md:flex-row md:justify-between mt-12">
        <div className="flex flex-col justify-center items-center md:items-start h-full md:w-1/2 md:ml-8">
          <p className="text-primary font-bold mb-2">Hey There 👋 I am</p>
          <h1 className="text-2xl md:text-4xl font-bold mb-2">
            Vincent Truong
          </h1>
          <h2 className="text-sm md:text-lg font-bold mb-4">
            <span className="text-gray">Professional</span> Software Developer
          </h2>
          <p className="text-sm md:text-lg text-gray mb-8">
            Hier ist der Text für deine Komponente.
          </p>
          <Button rounded color="primary">
            Contact Me
          </Button>
        </div>
        <div className="flex justify-center md:justify-end items-end mt-8 md:mt-0 md:w-1/2">
          <img
            src="./static/Objekt 3.png"
            alt="Bild"
            className="z-40 h-64 md:h-72 mt-8 md:mt-0 -ml-4 md:mr-16"
          />
          <div className="-mr-10 md:mr-8 absolute w-64 h-48 md:h-56 bg-primary rounded-full rounded-br-none" />
        </div>
      </div>
    </TemplateFrame>
  );
}

export default Banner;
